<div class="profile" [ngClass]="{'submenu-open': isSubmenuOpen}">
  <button
    class="img overflow-hidden cursor-pointer"
    (click)="toggleSubmenu()"
    (keyup)="onKeyUp($event, 'submenu')"
    tabindex="0"
  >
    <app-user-avatar
      [name]="user?.username"
      [firstname]="user?.firstname"
      [lastname]="user?.lastname"
      [picture]="user?.picture"
      [size]="36"
    ></app-user-avatar>
  </button>
  @if (!isMobile) {
  <div class="profile__submenu">
    <ul>
      <li>
        <a class="arrow" routerLink="/account/profile">{{
          "MY_PROFILE" | translate
        }}</a>
      </li>
      <li>
        <a class="arrow" routerLink="/account/preferences">{{
          "MY_PREFERENCES" | translate
        }}</a>
      </li>
      <li>
        <a class="arrow" routerLink="/account/imports">{{
          "ACCOUNT_IMPORTS_NAV_CTA" | translate
        }}</a>
      </li>
      <li>
        <a class="arrow" routerLink="/friends">{{
          "MY_FRIENDS" | translate
        }}</a>
      </li>
      <li>
        <a class="arrow" routerLink="/stats">{{ "STATISTICS" | translate }}</a>
      </li>
      @if (user && user.role && user.role >= 5) {
      <li>
        <a class="arrow" routerLink="/admin"
          ><span class="text-primary-text">{{ "ADMIN" | translate }}</span></a
        >
      </li>
      }
      <li>
        <button
          class="inline-block font-bold text-form-error dark:text-form-errorLight"
          (click)="logout()"
          (keyup)="onKeyUp($event, 'logout')"
          tabindex="0"
        >
          {{ "LOG_OUT" | translate }}
        </button>
      </li>
    </ul>
  </div>
  }
</div>
